module.exports = __webpack_public_path__ + "static/booksonwall-f1333be8c6c5f1bed44141e4b221ddad.png";